// Initialise and observe animate on scroll.
(function () {
  if (!document.body.classList.contains('cc-animate-enabled')) return;

  if (!('IntersectionObserver' in window)) {
    document.body.classList.remove('cc-animate-enabled');
    return;
  }

  var aosMinWidth = getComputedStyle(document.documentElement).getPropertyValue('--aos-min-width') || '0';
  var mediaQuery = window.matchMedia('(min-width: ' + aosMinWidth + 'px)');
  var observer = null;
  var scheduled = false;

  function reveal(entryObserver, elem) {
    elem.classList.add('cc-animate-in');
    entryObserver.unobserve(elem);
  }

  function setupElement(elem) {
    if (elem.classList.contains('cc-animate-init')) return;

    if (elem.dataset.ccAnimateDelay) {
      elem.style.animationDelay = elem.dataset.ccAnimateDelay;
    }

    if (elem.dataset.ccAnimateDuration) {
      elem.style.animationDuration = elem.dataset.ccAnimateDuration;
    }

    if (elem.dataset.ccAnimate) {
      elem.classList.add(elem.dataset.ccAnimate);
    }

    elem.classList.add('cc-animate-init');
    observer.observe(elem);
  }

  function initAnimateOnScroll(root) {
    if (!mediaQuery.matches) return;

    var scope = root && root.querySelectorAll ? root : document;
    var animatableElems = scope.querySelectorAll('[data-cc-animate]:not(.cc-animate-init)');

    animatableElems.forEach(setupElement);
  }

  function scheduleInit(root) {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      initAnimateOnScroll(root || document);
    });
  }

  observer = new IntersectionObserver(function (entries, entryObserver) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && !entry.target.classList.contains('cc-animate-in')) {
        reveal(entryObserver, entry.target);
      }
    });
  });

  if (mediaQuery.matches) {
    initAnimateOnScroll(document);
  } else {
    document.body.classList.remove('cc-animate-enabled');
  }

  try {
    mediaQuery.addEventListener('change', function (event) {
      document.body.classList.toggle('cc-animate-enabled', event.matches);
      if (event.matches) scheduleInit(document);
    });
  } catch (e) {
    // Older Safari versions may not support MediaQueryList.addEventListener.
  }

  document.addEventListener('shopify:section:load', function (event) {
    scheduleInit(event.target);
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (!('MutationObserver' in window)) return;

    var mutationObserver = new MutationObserver(function (records) {
      var needsInit = false;

      records.some(function (record) {
        return Array.prototype.some.call(record.addedNodes, function (node) {
          if (node.nodeType !== 1) return false;
          if (node.matches && node.matches('[data-cc-animate]:not(.cc-animate-init)')) {
            needsInit = true;
            return true;
          }
          if (node.querySelector && node.querySelector('[data-cc-animate]:not(.cc-animate-init)')) {
            needsInit = true;
            return true;
          }
          return false;
        });
      });

      if (needsInit) scheduleInit(document);
    });

    mutationObserver.observe(document.body, {
      subtree: true,
      childList: true
    });
  });

  window.theme = window.theme || {};
  window.theme.initAnimateOnScroll = initAnimateOnScroll;
}());
